export const FEEDBACK_CONSTANTS: string[] = [
    'I don\'t need more cover',
    'This plan is difficult to understand',
    'The pricing is too high',
    'I don\'t have time right now',
    'Other'
];
